import { render, staticRenderFns } from "./html-editor.vue?vue&type=template&id=22364672&scoped=true&"
import script from "./html-editor.vue?vue&type=script&lang=js&"
export * from "./html-editor.vue?vue&type=script&lang=js&"
import style0 from "./html-editor.vue?vue&type=style&index=0&id=22364672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22364672",
  null
  
)

export default component.exports